import { RetirementDropNoteType } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementDropTiming } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const getRetirementDropTiming = (
	endYear: number,
	retirementYear: number,
): RetirementDropTiming =>
	endYear <= retirementYear
		? {
				deductible: true,
				note: { type: RetirementDropNoteType.EndsBefore, year: endYear },
			}
		: {
				deductible: false,
				note: { type: RetirementDropNoteType.EndsAfter, year: endYear },
			};
